import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm3.031 13.605h-1.149v-4.823l-1.584 2.585h-.763l-1.594-2.585v4.823H8.792V8.672h1.149l1.99 3.238 1.992-3.238h1.109v6.933z" }));
export default createSvgIcon(iconPath, "Mods");
//# sourceMappingURL=ModsIcon.js.map